module.exports = __webpack_public_path__ + "d35efe6b08e42a61ae1e861bf5eb5f1b.svg";